export const GetSpotOpenOrderList = ({
  coinSourceId,
  coinDestinationId,
  sideId,
  typeId,
  pageNumber,
  pageSize,
}) =>
  `/Order/GetSpotOpenOrderList?CoinSourceId=${coinSourceId}&CoinDestinationId=${coinDestinationId}&SideId=${sideId}&TypeId=${typeId}&PageNumber=${pageNumber}&PageSize=${pageSize}`;

export const GetMarginOpenOrderList = ({
  coinSourceId,
  coinDestinationId,
  sideId,
  typeId,
  pageNumber,
  pageSize,
}) =>
  `/Order/GetMarginOpenOrderList?CoinSourceId=${coinSourceId}&CoinDestinationId=${coinDestinationId}&SideId=${sideId}&TypeId=${typeId}&PageNumber=${pageNumber}&PageSize=${pageSize}`;

export const GetSpotTradeLast24HList = "/Trade/GetSpotTradeLast24HList";

export const GetMarginTradeLast24HList = "/Trade/GetMarginTradeLast24HList";

export const CancelOrder = "/Order/CancelOrder";

export const GetTradeForm = "/Trade/GetTradeForm";

export const GetHistoryOrderForm = "/Order/GetHistoryOrderForm";

export const GetTradeInitial = ({
  coinId,
  sideId,
  walletTypeId,
  coinMasterId,
}) =>
  `/Trade/GetTradeInitial?CoinId=${coinId}&CoinMasterId=${coinMasterId}&SideId=${sideId}&WalletTypeId=${walletTypeId}`;

export const GetTradeAmountMax = ({
  coinId,
  coinMasterId,
  sideId,
  walletTypeId,
}) =>
  `/Trade/GetTradeAmountMax?CoinId=${coinId}&CoinMasterId=${coinMasterId}&SideId=${sideId}&WalletTypeId=${walletTypeId}`;

export const TradeInsertInitial = "/Trade/TradeInsertInitial";

export const TradeInsertConfirmedUser = "/Trade/TradeInsertConfirmedUser";

export const GetHistoryOrderList = ({
  coinSourceId,
  coinDestinationId,
  sideId,
  typeId,
  walletTypeId,
  startDate,
  endDate,
  pageNumber,
  pageSize,
}) =>
  `/Order/GetHistoryOrderList?CoinSourceId=${coinSourceId}&CoinDestinationId=${coinDestinationId}&SideId=${sideId}&TypeId=${typeId}&WalletTypeId=${walletTypeId}&stateId=0&PageNumber=${pageNumber}&PageSize=${pageSize}&StartDate=${startDate}&EndDate=${endDate}`;

export const GetTradeList = ({
  coinSourceId,
  coinDestinationId,
  sideId,
  typeId,
  walletTypeId,
  startDate,
  endDate,
  pageNumber,
  pageSize,
}) =>
  `/Trade/GetTradeList?CoinSourceId=${coinSourceId}&CoinDestinationId=${coinDestinationId}&SideId=${sideId}&TypeId=${typeId}&WalletTypeId=${walletTypeId}&PageNumber=${pageNumber}&PageSize=${pageSize}&StartDate=${startDate}&EndDate=${endDate}`;
